/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_JobsInputs */

const en_nav_jobs = /** @type {(inputs: Nav_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobs`)
};

const he_nav_jobs = /** @type {(inputs: Nav_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`משימות`)
};

/**
* | output |
* | --- |
* | "Jobs" |
*
* @param {Nav_JobsInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const nav_jobs = /** @type {((inputs?: Nav_JobsInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_JobsInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_jobs(inputs)
	return he_nav_jobs(inputs)
});